import React from "react";
import { Button, Flex } from "rebass";

import { Replay30SVG } from "../svg/ReplaySVG";
import { Forward30SVG } from "../svg/ForwardSVG";

import { ToggleIcon } from "./ToggleIcon";
import { useTogglePlay } from "../../hooks/useTogglePlay";
import { useSkipForward, useSkipBackward } from "../../hooks/useSkip";

const buttonCommonProps = { px: 0, py: 0, bg: "transparent" };
const iconCommonProps = { size: 30, fill: "currentColor" };

export const StreamControl: React.FC = () => {
  const { isPlaying, togglePlay } = useTogglePlay();
  const skipBackward = useSkipBackward();
  const skipForward = useSkipForward();

  return (
    <Flex>
      <Button
        {...buttonCommonProps}
        color="wild-blue"
        onClick={skipBackward}
      >
        <Replay30SVG {...iconCommonProps} />
      </Button>

      <Button
        {...buttonCommonProps}
        mx="10px"
        color="sp-blue"
        onClick={togglePlay}
      >
        <ToggleIcon isPlaying={isPlaying} />
      </Button>

      <Button
        {...buttonCommonProps}
        color="wild-blue"
        onClick={skipForward}
      >
        <Forward30SVG {...iconCommonProps} />
      </Button>
    </Flex>
  );
};
